/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiAttributeMapping
 */
export interface ApiAttributeMapping {
    /**
     * 
     * @type {number}
     * @memberof ApiAttributeMapping
     */
    id?: number;
    /**
     * 
     * @type {ApiAttributeMappingFieldEnum}
     * @memberof ApiAttributeMapping
     */
    field: ApiAttributeMappingFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiAttributeMapping
     */
    mapping: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAttributeMapping
     */
    booleanTrueValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAttributeMapping
     */
    format?: string;
}

/**
* @export
* @enum {string}
*/
export enum ApiAttributeMappingFieldEnum {
    TO_ACCOUNT = 'TO_ACCOUNT',
    FROM_ACCOUNT = 'FROM_ACCOUNT',
    AMOUNT = 'AMOUNT',
    CREDIT = 'CREDIT',
    TO_NAME = 'TO_NAME',
    FROM_NAME = 'FROM_NAME',
    DATE_COMPLETED = 'DATE_COMPLETED',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    COMPANY_NAME = 'COMPANY_NAME',
    STATUS = 'STATUS'
}


/**
 * Check if a given object implements the ApiAttributeMapping interface.
 */
export function instanceOfApiAttributeMapping(value: object): value is ApiAttributeMapping {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('mapping' in value) || value['mapping'] === undefined) return false;
    return true;
}

export function ApiAttributeMappingFromJSON(json: any): ApiAttributeMapping {
    return ApiAttributeMappingFromJSONTyped(json, false);
}

export function ApiAttributeMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAttributeMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'field': json['field'],
        'mapping': json['mapping'],
        'booleanTrueValue': json['booleanTrueValue'] == null ? undefined : json['booleanTrueValue'],
        'format': json['format'] == null ? undefined : json['format'],
    };
}

export function ApiAttributeMappingToJSON(json: any): ApiAttributeMapping {
    return ApiAttributeMappingToJSONTyped(json, false);
}

export function ApiAttributeMappingToJSONTyped(value?: ApiAttributeMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'field': value['field'],
        'mapping': value['mapping'],
        'booleanTrueValue': value['booleanTrueValue'],
        'format': value['format'],
    };
}

